<template>
  <div ref="dropdownContainer" class="relative">
    <div :style="dropdownStyle" style="width: 300px" class="absolute text-sm mt-1 bg-white border border-gray-200 rounded-xl shadow-lg z-10">
      <div class="p-2 border-b border-gray-200">
        <input
          v-model="searchQuery"
          :class="{ sensitive: sensitiveLabels }" :data-demo-search="sensitiveLabels ? '' : null"
          type="text"
          placeholder="Search..."
          class="w-full px-3 py-1 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-dark"
        />
      </div>
      <ul class="py-1 text-gray-700 overflow-y-auto grow">
        <li
          v-for="option in filteredPaginatedOptions"
          :key="option.id"
          class="px-4 py-1 hover:bg-gray-100 cursor-pointer flex items-center"
          @click="emitChangeStatic(option)"
        >
          <span :class="{ sensitive: sensitiveLabels }" :data-spoof-kind="spoofKind || undefined">{{ option.name }}</span>
        </li>
        <li v-if="filteredPaginatedOptions.length === 0" class="px-4 py-2 text-gray-500 italic">
          No matching results
        </li>
      </ul>
      <div v-if="shouldPaginate" class="flex justify-between items-center p-2 bg-gray-100 border-t">
        <button :disabled="currentPage === 1" class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="prevPage">Prev</button>
        <span>Page {{ currentPage }} of {{totalFilteredPages}}</span>
        <button :disabled="currentPage === totalFilteredPages" class="px-2 py-1 hover:bg-gray-300 bg-gray-200 border border-gray-300 rounded" @click="nextPage">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import Spinning_Loader from '@/components/widgetcomponents/Viz_Elements/Spinning_Loader.vue';
import demoProtectedFields from '@/mixins/demoProtectedFields';

export default {
  components: {Spinning_Loader},
  mixins: [demoProtectedFields],
  // With sensitiveLabels the options are identities (tenants, entities): the
  // labels are tagged, and the search typed over them is emptied and
  // read-only in Demo Mode. Without it both stay readable and usable.
  demoProtectedFields() {
    return this.sensitiveLabels ? ['searchQuery'] : [];
  },
  props: {
    options: Array,
    initial: Array,
    multiple: Boolean,
    // Defaults to true: every caller lists customer tenants or entities.
    // Callers still pass it explicitly (scripts/demo-coverage rule 8).
    sensitiveLabels: { type: Boolean, default: true },
    // 'tenant' spoofs labels from the fake tenant pool (see demoSpoof.js).
    spoofKind: { type: String, default: null },
  },
  data() {
    return {
      selectedOptions: this.initial || [],
      dropdownStyle: {},
      currentPage: 1,
      itemsPerPage: 20,
      searchQuery:''
    }
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery) {
        return this.options;
      }

      const query = this.searchQuery.toLowerCase();
      return this.options.filter(option =>
        option.name.toLowerCase().includes(query)
      );
    },
    filteredPaginatedOptions() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredOptions.slice(start, end);
    },
    totalFilteredPages() {
      return Math.ceil(this.filteredOptions.length / this.itemsPerPage);
    },
    shouldPaginate() {
      return this.options.length > this.itemsPerPage
    },
  },
  methods: {
    handleClickOutside(event) {
      // Only handle clicks that are outside both the dropdown and its trigger
      const isOutsideDropdown = !this.$refs.dropdownContainer.contains(event.target);
      const isOutsideTrigger = !event.target.closest('[data-dropdown-trigger]');

      if (isOutsideDropdown && isOutsideTrigger) {
        this.closeDropdown();
      }
    },
    closeDropdown() {
      this.$emit('close');
    },
    emitChangeStatic(value) {
      this.$emit('select', value);
      this.closeDropdown();
    },
    nextPage() {
      if (this.currentPage < this.totalFilteredPages) {this.currentPage++}
    },
    prevPage() {
      if (this.currentPage > 1) {this.currentPage--}
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside, true)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  },
}
</script>
